var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-selector" }, [
    _c(
      "div",
      {},
      [
        _vm.item.item_id
          ? _c("div", { staticClass: "selected-item" }, [
              _vm._v("\n      " + _vm._s(_vm.item.part_number) + "\n      "),
            ])
          : _c("base-select", {
              staticClass: "multi-select-item",
              attrs: {
                options: _vm.itemOptions,
                "show-labels": false,
                "preserve-search": true,
                "initial-search": _vm.item.part_number,
                invalid: _vm.invalid,
                placeholder: _vm.$t("invoices.item.select_an_item"),
                label: "part_number",
              },
              on: {
                select: function (val) {
                  return _vm.$emit("select", val)
                },
              },
              model: {
                value: _vm.itemSelect,
                callback: function ($$v) {
                  _vm.itemSelect = $$v
                },
                expression: "itemSelect",
              },
            }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }